import { Filter } from './Filter';
import PropTypes from 'prop-types';
import { useTheme } from 'styled-components';
import { useTranslation } from 'react-i18next';
import {
    Container,
    DateRangePickerContainer,
    FilterBox,
    FilterContainer,
    FooterContainer,
    Header,
    IconContainer,
    List,
    Row,
    SearchContainer,
    Title
} from './styled';
import {
    DateRangePicker,
    ExpandButton,
    Input,
    MaterialIcon
} from 'mol-ui';
import React, { useEffect, useState } from 'react';

const ListingLayout = ({
    children,
    endValue,
    filterDates,
    filterOptions,
    footer,
    handleAdd,
    handleFilter,
    handleFilterDates,
    handleSearch,
    handleSearchEnabled,
    onSearchValueChange = () => null,
    hideAddItem,
    searchValue,
    showCounter,
    startValue,
    title,
    width
}) => {

    const { t } = useTranslation();
    const { textColor } = useTheme();
    const [input, setInput] = useState('');

    useEffect(() => {
        setInput(searchValue);
    }, [searchValue, setInput]);

    const clearSearch = () => {
        handleSearch('');
        setInput('');
    };

    const handleChangeValue = value => {
        setInput(value);
        onSearchValueChange(value);
    };

    return (
        <Container filterDates={ filterDates } width={ width }>
            <Header>
                <FilterBox>
                    {
                        !!title &&
                        <Title>
                            { title }
                        </Title>
                    }
                    {
                        handleAdd && !hideAddItem &&
                        <ExpandButton
                            circle
                            fontSize={ 15 }
                            icon="add"
                            size={ 25 }
                            onClick={ handleAdd }
                        />
                    }
                </FilterBox>
                <SearchContainer onClick={ handleSearchEnabled }>
                    <Row>
                        <Input
                            fontSize="12px"
                            icon="search"
                            marginBottom="0px"
                            placeholder={ ` ${ t('Buscar') }...` }
                            value={ input ?? '' }
                            width="180px"
                            onChange={ handleChangeValue }
                            onEnterPress={ () => handleSearch(input) }
                        />
                        {
                            !!input &&
                            <IconContainer
                                onClick={ clearSearch }
                            >
                                <MaterialIcon color={ textColor } icon="close" size={ 25 } />
                            </IconContainer>
                        }
                        <FilterContainer>
                            <Filter counter={ showCounter } filterOptions={ filterOptions } handleFilter={ handleFilter } />
                        </FilterContainer>
                    </Row>
                    {
                        filterDates &&
                        <Row>
                            <DateRangePickerContainer>
                                <DateRangePicker
                                    allowFutureDays={ false }
                                    endValue={ endValue }
                                    margin="5px 0px 0px auto"
                                    position="right"
                                    startValue={ startValue }
                                    onChange={ handleFilterDates }
                                />
                            </DateRangePickerContainer>
                        </Row>
                    }
                </SearchContainer>
            </Header>
            <List hasFooter={ !!footer }>
                { children }
            </List>
            {
                !!footer &&
                <FooterContainer>
                    { footer }
                </FooterContainer>
            }
        </Container>
    );
};

ListingLayout.propTypes = {
    children: PropTypes.any,
    endValue: PropTypes.string,
    filterDates: PropTypes.bool,
    filterOptions: PropTypes.array,
    footer: PropTypes.any,
    handleAdd: PropTypes.func,
    handleFilter: PropTypes.func,
    handleFilterDates: PropTypes.func,
    handleSearch: PropTypes.func,
    handleSearchEnabled: PropTypes.func,
    hideAddItem: PropTypes.bool,
    onSearchValueChange: PropTypes.func,
    searchValue: PropTypes.string,
    showCounter: PropTypes.number,
    startValue: PropTypes.string,
    title: PropTypes.string,
    width: PropTypes.number
};

ListingLayout.displayName = 'ListingLayout';

export { ListingLayout };
